'use client';
import Typography from '@/components/shared/typography/typography.component';
import classes from './styles.module.scss';

const FilterTabItem = ({
  text,
  selected,
  tabClicked,
  count,
  id,
}: {
  text: string;
  selected: boolean;
  tabClicked: (id: string | number) => void;
  count: number;
  id: string | number;
}) => {
  return (
    <button
      onClick={() => tabClicked(id)}
      className={`${classes.container} ${selected ? classes.active : ''}`}
    >
      <Typography className={classes.container__text} variant={'body2Medium'}>
        {text}
      </Typography>
      {count > 0 && (
        <div className={`${classes.container__count} ${selected ? classes.active : ''}`}>
          {count}
        </div>
      )}
    </button>
  );
};

export default FilterTabItem;
